<template>
	<!-- w问答 -->
	<div class="p_m_t_30">
		<div class="p_flex">
			<div class="xuan type_size_22">题目内容</div>
			<div class="choice_input p_m_l_30">
				<question-wangeditor
					ref="childs"
					v-model="topicContent.title"
					:name="topic"
					:option="1"
					:height="120"
					:width="840"
					:val="topicVal"
				></question-wangeditor>
			</div>
		</div>
		<div class="p_flex p_m_t_30">
			<div class="xuan  p_flex p_f_e type_size_22">答案</div>
			<div class="choice_input p_m_l_30">
				<el-input type="textarea" :rows="2" @change="changeInput" placeholder="请输入答案" :autosize="{ minRows: 4, maxRows: 99 }" v-model="answerVal"></el-input>
				<!-- <question-wangeditor
					ref="childs"
					v-model="topicContent.affiliation.text"
					:name="answer"
					:option="1"
					:height="120"
					:width="840"
					:val="answerVal"
				></question-wangeditor> -->
			</div>
		</div>
		<div class="p_flex p_m_t_30">
			<div class="xuan  p_flex p_f_e type_size_22">学生答题</div>
			<div class="choice_input p_m_l_30">
				<el-radio-group v-model="radio" @change="change">
					<el-radio :label="1">文字答题</el-radio>
					<el-radio :label="2">上传图片答题</el-radio>
					<el-radio :label="3">全部</el-radio>
				</el-radio-group>
			</div>
		</div>
	</div>
</template>

<script>
import QuestionWangeditor from './questionWangeditor.vue';
export default {
	components: {
		QuestionWangeditor
	},
	data() {
		return {
			// 题目内容
			topic: 'topic',
			topicVal: '',
			// 答案
			answer: 'answer',
			answerVal: '',
			radio: 3
		};
	},
	props: {
		topicContent: {
			type: Object
			// default() {
			// 	return this.$refs['childs'].getHtml();
			// }
		},
		clear:null
	},
	watch:{
		clear(n,o){
			if( n ){
				this.$refs.childs.sing()
				this.answerVal = ''
			}
		}
	},
	created() {
		this.topicContent.affiliation = []
		this.topicContent.answer = ''
		this.topicContent.answer_mode = this.radio
	},
	mounted() {},
	methods: {
		change(e){
			this.topicContent.answer_mode = e
		},
		changeInput(e){
			this.topicContent.answer = e
		}
	}
};
</script>

<style lang="scss" scoped>
.choice_input {
	width: 840px;
}

.xuan {
	width: 88px;
}
>>> .el-input__inner {
	border: none;
	background-color: #f5f5f5;
	font-size: 18px;
	color: #333;
	padding: 0;
}

>>> input::-webkit-input-placeholder {
	font-size: 18px;
}

>>> .el-input-group__prepend {
	border: none;
}
>>> .el-input-group__append,
>>> .el-input-group__prepend {
	font-size: 18px;
}
>>> .el-input-group__append,
>>> .el-input-group__prepend {
	border: none;
}
>>> .el-radio__input.is-checked .el-radio__inner {
	border-color: #00af63;
	background: #00af63;
}
>>> .el-radio__input.is-checked + .el-radio__label {
	color: #00af63;
}
>>> .el-radio__inner {
	width: 20px;
	height: 20px;
}
>>> .el-radio__label {
	font-size: 18px;
}
>>> .el-radio__inner:hover {
	border-color: #999999;
}
>>> .el-radio__inner::after {
	width: 8px;
	height: 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/homet/commponents/singleAnswers.vue